import React, { useState } from 'react';
import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import MessageInput from './MessageInput';

const ChatArea = ({ 
    currentChat, 
    currentChatType, 
    onSendMessage,
    onShowGroupInfo,
    onToggleTheme,
    isDark
}) => {
    if (!currentChat) {
        return (
            <div className="chat-area">
                <div className="messages-area">
                    <div style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: '2rem', position: 'relative', zIndex: 1 }}>
                        <i className="fas fa-comments" style={{ fontSize: '3rem', color: 'var(--primary)', marginBottom: '1rem', display: 'block' }}></i>
                        Выберите чат или группу для начала общения
                    </div>
                </div>
            </div>
        );
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [searchInChat, setSearchInChat] = useState('');
    return (
        <div className="chat-area">
            <div className="input-group" style={{ marginTop: '0.75rem' }}>
                <input
                    type="text"
                    placeholder="Поиск..."
                    className="message-input"
                    value={searchInChat}
                    onChange={(e) => setSearchInChat(e.target.value)}
                    style={{ borderWidth: '1px' }}
                />
            </div>
            <ChatHeader 
                chat={currentChat}
                chatType={currentChatType}
                onShowGroupInfo={onShowGroupInfo}
                onToggleTheme={onToggleTheme}
                isDark={isDark}
            />
            <MessageList 
                messages={currentChat.messages}
                chatType={currentChatType}
            />
            <MessageInput onSendMessage={onSendMessage} />
        </div>
    );
};

export default ChatArea;
